import { Box, Button, IconButton, useMediaQuery } from "@material-ui/core";
import { ImportExport } from "@material-ui/icons";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import peoplefineLogo from "../../assets/images/peoplefine-logo-reporting.png";
import { theme } from "../../utils/Theme";

export const DownloadPDFFile = ({ csvData, fileName, clientName }) => {
  const exportToPDF = () => {
    const doc = new jsPDF("landscape");
    const allColumns = [
      { title: "N°", getValue: (value, index) => index + 1 },
      { title: "Candidat", getValue: (value) => value.candidatNom + " " + value.candidatPrenom },
      { title: "Mission", getValue: (value) => value.nom_mission },
      { title: "Envoi", getValue: (value) => value.sent ? moment(value.sent).format("DD/MM/yyyy") : "-" },
      { title: "Révélation", getValue: (value) => value.revealed ? moment(value.revealed).format("DD/MM/yyyy") : "-" },
      { title: "E1", getValue: (value) => value.e1 ? moment(value.e1).format("DD/MM/yyyy") : "-" },
      { title: "E2", getValue: (value) => value.e2 ? moment(value.e2).format("DD/MM/yyyy") : "-" },
      { title: "E3", getValue: (value) => value.e3 ? moment(value.e3).format("DD/MM/yyyy") : "-" },
      { title: "E4", getValue: (value) => value.e4 ? moment(value.e4).format("DD/MM/yyyy") : "-" },
      { title: "E5", getValue: (value) => value.e5 ? moment(value.e5).format("DD/MM/yyyy") : "-" },
      { title: "Propale", getValue: (value) => value.proposition ? value.proposition : "-" },
      { title: "Signature", getValue: (value) => value.signature ? moment(value.signature).format("DD/MM/yyyy") : "-" },
      { title: "Commentaires", getValue: (value) => value.commentaire && value.commentaire.length > 0 ? value.commentaire.map((item) => item.note.replace(/<[^>]*>/g, "").trim()).filter(Boolean).join(" | ") : "-" },
    ];

    const rawData = csvData.map((value, index) =>
      allColumns.map((col) => col.getValue(value, index))
    );

    const activeColIndexes = allColumns
      .map((_, colIdx) => colIdx)
      .filter((colIdx) => colIdx === 0 || rawData.some((row) => row[colIdx] !== "-"));

    const tableColumnTitles = activeColIndexes.map((i) => allColumns[i].title);
    const tableData = rawData.map((row) => activeColIndexes.map((i) => row[i]));
    const logoWidth = 50;
    const logoX = 13;
    const logoY = 8;
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.addImage(peoplefineLogo, "PNG", logoX, logoY - 1, logoWidth, 15);

    let title = `REPORTING PEOPLEFINE - ${clientName} - ${moment().format(
      "D/MM/YYYY"
    )}`;
    if (!clientName) {
      title = `REPORTING PEOPLEFINE - ${moment().format("D/MM/YYYY")}`;
    }

    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;

    const startX = (pageWidth - titleWidth) / 2;
    doc.setFont("bold");
    doc.text(title, startX, 25);
    doc.setFontSize(16);

    const headerText = "";
    // const headerText = "Statut: A (Active) / P (Passive)";
    const headerTextWidth = doc.getStringUnitWidth(headerText) * 10;
    const headerX = pageWidth - headerTextWidth + 70;
    const headerY = 10;

    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text(headerText, headerX, headerY);
    doc.autoTable({
      head: [tableColumnTitles],
      body: tableData,
      startY: 30,
      theme: "grid",
      styles: { fontSize: 10, valign: "middle", halign: "center" },
      headStyles: {
        fillColor: "#ffffff",
        textColor: "#000",
        lineWidth: 0.1,
        lineColor: "#000",
        fontSize: 10,
        valign: "middle",
        halign: "start",
      },
      bodyStyles: {
        halign: "start",
        valign: "middle",
        fontSize: 10,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      cellStyles: { overflow: "linebreak", fontSize: 11 },
    });


    doc.setTextColor(0);

    const addressText = "Adr: 66 avenue des Champs-Elysées, 75008 PARIS";
    const emailText = "Email: contact@peoplefine.com";
    const siteWeb = "Site: www.peoplefine.com";
    const phone = "Tél: +33 1 82 82 98 30";

    const footerTexts = [addressText, emailText, siteWeb, phone];
    const startY = doc.internal.pageSize.getHeight() - 20;

    footerTexts.forEach((text, index) => {
      const y = startY + (index * 5);
      const x = 138 - (doc.getStringUnitWidth(text) * 2);
      doc.text(text, x, y);
    });

    doc.save(`REPORTING PEOPLEFINE-${clientName}-${fileName}.pdf`);
  };

  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      {!isSmMode ? (
        <Button
          startIcon={<ImportExport />}
          style={{ backgroundColor: "rgb(17, 122, 167)", color: "#FFF" }}
          onClick={exportToPDF}
        >
          Export
        </Button>
      ) : (
        <IconButton data-toggle="tooltip"
          title="Exporter" onClick={exportToPDF} size="medium">
          <ImportExport />
        </IconButton>
      )}
    </Box>
  );
};

export default DownloadPDFFile;
